export default "__VITE_ASSET__6TGApt5H__"